import React from 'react'
import { SectionHeader, Header2 } from '../../styles/Components'
import MarketSelector from '../MarketSelector'

const Location = ({ markets, setSelectedMarket, selectedMarket }) => {
  return (
    <div className="gift-card-location-container">
      <SectionHeader margin="0 0 9px 0" small>
        Step 2
      </SectionHeader>
      <Header2 align="center" margin="0 0 35px 0">
        Where&apos;s the recipient&apos;s location?
      </Header2>
      {markets.length > 0 && (
        <MarketSelector
          markets={markets}
          selected={selectedMarket}
          setSelected={setSelectedMarket}
        />
      )}
      <div className="divider location-divider" />
    </div>
  )
}

export default Location
